export function paramsToObject(entries: Iterable<[string, string]>) {
  const result: Record<string, string> = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

export function queryParamsToString(searchParams: URLSearchParams) {
  return `?${new URLSearchParams(Object.fromEntries(searchParams.entries())).toString()}`;
}
